export interface U2103GetSecretKeyHandlersHandlersParams<T = unknown> {
  doGetSecretKeyFn: () => Promise<unknown>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: unknown }) => void;
}

export interface U2103GetSecretKeyHandlersReturn {
  GetSecretKey: () => void;
}

export function useU2103GetSecretKeyHandlers<T extends { id: string } = { id: string }>({ doGetSecretKeyFn, onSuccess, onError }: U2103GetSecretKeyHandlersHandlersParams<T>): U2103GetSecretKeyHandlersReturn {
  const GetSecretKey = async () => {
    try {
      const response = await doGetSecretKeyFn() as { data: { result: T } };
      const row: T = response.data.result;

      if (onSuccess) {
        onSuccess(row);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { GetSecretKey };
}
